import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import { optionHover } from '../../styles/shareableStyles';

export const UserContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  column-gap: 8px;
  padding: 8px 12px;
`;

export const UserInfo = styled.div`
  flex: 1;
  line-height: normal;
`;

export const UserName = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const UserEmail = styled.div`
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
`;

export const IconContainer = styled.div<{
  $isActive?: boolean;
}>`
  display: flex;
  align-items: center;
  column-gap: 4px;
  height: 32px;
  padding-right: 4px;
  padding-left: 4px;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.8);
  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    color: ${theme.colors.white};
    cursor: pointer;
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: rgba(255, 255, 255, 0.1);
      color: ${theme.colors.white};
      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    `}
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  background: none;
  border: none;
  transition: color 0.2s ease-in-out;
  color: ${theme.colors.secondary900};
  &:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:not(:disabled):hover {
    cursor: pointer;
    ${optionHover};
  }
  &:disabled {
    color: ${theme.colors.secondary400};
  }
`;

export const Logo = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 2px solid ${theme.colors.white};
  user-select: none;
`;
